<template>
  <div class="userManagement-container">
    <el-row>
      <el-col :span="12">
        <zr-query-form class="query-box">
          <zr-query-form-left-panel :span="24">
            <el-button icon="el-icon-plus" type="primary" @click="handleAddSon"
              >添加子部门</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-edit-outline"
              @click="handleEdit"
              >编辑
            </el-button>
            <el-button type="success" icon="el-icon-s-order" @click="handleView"
              ><span>查看</span>
            </el-button>
          </zr-query-form-left-panel>
        </zr-query-form>
        <zr-tree-table
          ref="deptTreeTable"
          selection-type="single"
          row-key="name"
          node-key="code"
          height-fixed
          class="table-box"
          expand-all
          enabled-selection
          :loading-show="treeLoading"
          :columns="realDeptCols"
          :data="dataList"
          @row-click="rowClick"
          @current-change="deptOnclick"
        >
          <template v-slot:enabled="{ row }">
            <el-switch
              :value="row.enabled"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </template>
        </zr-tree-table>
      </el-col>
      <el-col :span="11" :push="1">
        <zr-query-form class="query-box">
          <zr-query-form-left-panel :span="24">
            <el-button icon="el-icon-plus" type="primary" @click="handleAddUser"
              >添加用户</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-edit-outline"
              @click="handleUserEdit"
              >编辑
            </el-button>
            <el-button
              type="success"
              icon="el-icon-s-order"
              @click="handleUserView"
              ><span>查看</span>
            </el-button>
            <el-button
              icon="el-icon-setting"
              type="warning"
              @click="handleResetPassword"
              >重置密码</el-button
            >
          </zr-query-form-left-panel>
        </zr-query-form>
        <zr-table
          ref="userPageTable"
          height-fixed
          class="user-box"
          :loading-show="userLoading"
          selection-type="single"
          :data="userList"
          :columns="realUserCols"
          enabled-selection
          stripe
          @row-click="userClick"
        >
          <template v-slot:enabled="{ row }">
            <el-switch
              :value="row.enabled"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </template>
        </zr-table>
      </el-col>
    </el-row>
    <zr-comm-dialog
      title="部门信息"
      :dialog-data="deptDialogData"
      :dialog-visible.sync="dialogVisible"
      :init-data-fun="initDialogData"
      :save-data-fun="saveDialogData"
      :rules="rules"
      :width="device == 'mobile' ? '90%' : '40%'"
      @dialogVisibleChange="dialogVisibleChange"
      @callBack="dialogDeptCallBack"
    >
      <template v-slot:dialog-content="{ form, dialogData }">
        <el-form-item label="部门名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="部门名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="部门编码" prop="deptCode">
          <el-input
            v-model="form.deptCode"
            :disabled="dialogData.action != 'add'"
            placeholder="部门编码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="部门级别" prop="deptLevel">
          <zr-combobox
            v-model="form.deptLevel"
            :data-array="levelArray"
            placeholder="部门级别"
            value-field="code"
            label-field="name"
          ></zr-combobox>
        </el-form-item>
        <el-form-item label="是否过滤" prop="isCorporation">
          <zr-combobox
            v-model="form.isCorporation"
            :data-array="isCorporationArray"
            placeholder="是否过滤"
            value-field="code"
            label-field="name"
          ></zr-combobox>
        </el-form-item>
        <el-form-item label="机构编码" prop="orgCode">
          <el-input
            v-if="form.isCorporation == '0'"
            v-model="form.orgCode"
            disabled
          ></el-input>
          <el-input v-else :value="form.deptCode" disabled> </el-input>
        </el-form-item>
        <el-form-item label="排序" prop="deptSort">
          <el-input-number v-model="form.deptSort" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item label="是否启用" prop="isUseable">
          <el-select v-model="form.isUseable" placeholder="请选择是否启用">
            <el-option
              v-for="item in isUseableArray"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门描述" prop="desp">
          <el-input
            v-model="form.desp"
            clearable
            type="textarea"
            maxlength="300"
            show-word-limit
            :rows="5"
            :autosize="{ minRows: 5, maxRows: 8 }"
            placeholder="部门描述"
          ></el-input>
        </el-form-item>
      </template>
    </zr-comm-dialog>
    <zr-comm-dialog
      title="用户信息"
      :dialog-data="dialogUserData"
      :dialog-visible.sync="dialogUserVisible"
      :init-data-fun="initDialogData"
      :save-data-fun="saveDialogUserData"
      :rules="userRules"
      :width="device == 'mobile' ? '90%' : '40%'"
      @dialogVisibleChange="dialogUserChange"
      @callBack="dialogUserCallBack"
    >
      <template v-slot:dialog-content="{ form, dialogData }">
        <el-form-item label="用户姓名" prop="fullName">
          <el-input
            v-model="form.fullName"
            placeholder="用户姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="用户代码" prop="code">
          <el-input
            v-model="form.userCode"
            :disabled="dialogData.action != 'add'"
            placeholder="用户代码"
            clearable
          ></el-input>
        </el-form-item>
        <!--        <el-form-item label="密级" prop="securityLevel">-->
        <!--          <zr-combobox-->
        <!--            v-model="form.securityLevel"-->
        <!--            :data-array="securityLevelArray"-->
        <!--            placeholder="密级"-->
        <!--            clearable-->
        <!--            value-field="code"-->
        <!--            label-field="name"-->
        <!--          ></zr-combobox>-->
        <!--        </el-form-item>-->
        <el-form-item label="排序" prop="userSort">
          <el-input-number v-model="form.userSort" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item label="是否启用" prop="isUseable">
          <el-select v-model="form.isUseable" placeholder="请选择是否启用">
            <el-option
              v-for="item in isUseableArray"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="form.remark"
            clearable
            type="textarea"
            maxlength="300"
            show-word-limit
            :rows="5"
            :autosize="{ minRows: 5, maxRows: 8 }"
            placeholder="备注"
          ></el-input>
        </el-form-item>
      </template>
    </zr-comm-dialog>
  </div>
</template>

<script>
import { searchBasicData } from "@api/framework/basicData/dataDictType";
import {
  findUsersByDeptCode,
  saveUser,
  resetUserPwd,
} from "@/api/framework/org/users";
import { getTree, saveDept } from "@/api/framework/org/depts";
import { defaultPageSizes } from "@/config/settings";
import { mapGetters } from "vuex";
import { messageDuration } from "../../../../config/settings";

export default {
  name: "DeptManagement",
  props: {
    min: {
      type: Number,
      default: 0.1,
    },
    max: {
      type: Number,
      default: 0.9,
    },
  },
  data() {
    return {
      queryForm: { deptName: "" },
      userList: [],
      dialogUserData: {},
      isUseableArray: [
        { code: 0, name: "不启用" },
        { code: 1, name: "启用" },
      ],
      securityLevelArray: [
        { code: "notSecret", name: "非密" },
        { code: "commonly", name: "一般" },
        { code: "import", name: "重要" },
      ],
      levelArray: [
        { code: "place", name: "一级部门" },
        { code: "point", name: "二级部门" },
      ],
      isCorporationArray: [
        { code: "1", name: "是" },
        { code: "0", name: "否" },
      ],
      columns: [
        {
          code: "name",
          name: "部门名称",
          headerAlign: "left",
          align: "left",
          fixed: "left",
          width: 190,
        },
        {
          code: "deptLevel",
          name: "部门级别",
          formatter: (row, value) => {
            const array = this.levelArray;
            for (let i = 0, len = array.length; i < len; i++) {
              if (array[i].code == value) {
                return array[i].name;
              }
            }
            return value;
          },
          width: 100,
        },
        { code: "deptCode", name: "部门编码" },
        {
          code: "isCorporation",
          name: "是否过滤",
          formatter: (row, value) => {
            const array = this.isCorporationArray;
            for (let i = 0, len = array.length; i < len; i++) {
              if (array[i].code == value) {
                return array[i].name;
              }
            }
            return value;
          },
          width: 120,
        },
        {
          code: "isUseable",
          name: "是否启用",
          formatter: (row, value) => {
            const array = this.isUseableArray;
            for (let i = 0, len = array.length; i < len; i++) {
              if (array[i].code == value) {
                return array[i].name;
              }
            }
            return value;
          },
          width: 120,
        },
        {
          code: "deptSort",
          name: "排序",
          formatter: (row, value) => {
            return value ? value : "";
          },
        },
      ],
      userColumns: [
        {
          code: "fullName",
          name: "用户姓名",
          align: "left",
          headerAlign: "left",
          fixed: "left",
          width: 120,
        },
        { code: "name", name: "登录账户", align: "left", fixed: "left" },
        { code: "userCode", name: "用户代码", align: "left", fixed: "left" },
        {
          code: "isUseable",
          name: "是否启用",
          formatter: (row, value) => {
            const array = this.isUseableArray;
            for (let i = 0, len = array.length; i < len; i++) {
              if (array[i].code == value) {
                return array[i].name;
              }
            }
            return value;
          },
        },
        {
          code: "userSort",
          name: "用户排序",
          formatter: (row, value) => {
            return value ? (value != "null" ? value : "") : "";
          },
        },
      ],
      dataList: [],
      curRow: null,
      curUser: null,
      mouseOver: false,
      treeLoading: false,
      userLoading: false,
      filterProps: {},
      deptDialogData: {},
      addInitData: {
        id: null,
        name: "",
        deptCode: "",
        deptLevel: "所级",
        parentCode: "",
        orgCode: "",
        deptSort: 1,
        isCorporation: "1",
        isUseable: 1,
        desp: "",
      },
      addInitUserData: {
        id: null,
        fullName: "",
        userCode: "",
        deptCode: "",
        securityLevel: null,
        userSort: 1,
        isUseable: 1,
        remark: "",
      },
      dialogVisible: false,
      dialogUserVisible: false,
      rules: {
        name: [
          { required: true, message: "请输入部门名称", trigger: "blur" },
          {
            min: 1,
            max: 15,
            message: "长度在 2 到 15 个字符",
            trigger: "blur",
          },
        ],
        deptCode: [
          { required: true, message: "请输入部门编码", trigger: "blur" },
          {
            min: 1,
            max: 15,
            message: "长度在 1 到 15 个字符",
            trigger: "blur",
          },
        ],
      },
      userRules: {
        name: [
          { required: true, message: "请输入登录账户", trigger: "blur" },
          {
            min: 1,
            max: 15,
            message: "长度在 2 到 15 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      device: "settings/device",
      orgCode: "user/orgCode",
    }),
    realDeptCols() {
      if (this.device == "mobile") {
        return this.columns.slice(0, 1);
      } else {
        return this.columns;
      }
    },
    realUserCols() {
      if (this.device == "mobile") {
        return [
          {
            code: "fullName",
            name: "用户姓名",
            align: "left",
            headerAlign: "left",
            fixed: "left",
            width: 120,
          },
          {
            code: "isUseable",
            name: "是否启用",
            formatter: (row, value) => {
              const array = this.isUseableArray;
              for (let i = 0, len = array.length; i < len; i++) {
                if (array[i].code == value) {
                  return array[i].name;
                }
              }
              return value;
            },
          },
        ];
      } else {
        return this.userColumns;
      }
    },
  },
  async created() {
    // await this.initUserSecurityLevel();
    await this.initDeptLevel();
    await this.fetchDeptsData();
  },
  methods: {
    userClick(row) {
      this.curUser = row;
    },
    async initDeptLevel() {
      const res = await searchBasicData({ typeCode: "deptLevel" });
      if (res.success) {
        this.levelArray = res.data.map((value) => {
          return { code: value.name, name: value.name };
        });
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    async initUserSecurityLevel() {
      const res = await searchBasicData({ typeCode: "user_securityLevel" });
      if (res.success) {
        //do
        this.securityLevelArray = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    async deptOnclick(row) {
      this.deptCode = row.deptCode;
      await this.usersByDeptCode(this.deptCode);
      this.curUser = undefined;
    },
    rowClick(row, column, event) {
      this.curRow = row;
    },
    async fetchDeptsData() {
      this.treeLoading = true;
      const res = await getTree({ orgCode: this.orgCode });
      if (res.success) {
        let data = res.data;
        this.dataList = data;
        this.$nextTick(() => {
          this.$refs.deptTreeTable.$refs.table.$refs.elTable.setCurrentRow(
            this.dataList[0]
          );
          this.rowClick(this.dataList[0]);
          // this.deptOnclick(this.dataList[0]);
        });
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }

      setTimeout(() => {
        this.treeLoading = false;
      }, 300);
    },
    handleAddUser() {
      if (this.curRow) {
        const deptCode = this.curRow.deptCode;
        this.dialogUserData = {
          action: "add",
          data: { ...this.addInitUserData, deptCode },
        };
        this.dialogUserVisible = true;
      } else {
        this.$message.warning({ showClose: true, message: "请选择部门" });
      }
    },
    async handleResetPassword() {
      const selects = this.$refs.userPageTable.getSelection();
      if (selects && selects.length > 0) {
        const res = await resetUserPwd({ users: JSON.stringify(selects) });
        if (res.success) {
          this.$message.success({
            showClose: true,
            message: "重置成功",
            duration: messageDuration,
          });
        } else {
          this.$message.error({ showClose: true, message: res.message });
        }
      } else {
        this.$message.warning({
          showClose: true,
          message: "选择要重置密码的用户",
        });
      }
    },
    async handleAddSon() {
      let parentCode = "";
      let orgCode = "";
      if (this.curRow) {
        parentCode = this.curRow.deptCode;
        orgCode = this.curRow.orgCode;
      } else {
        this.$message.warning({ showClose: true, message: "请选择父级" });
        return;
      }
      this.deptDialogData = {
        action: "add",
        data: { ...this.addInitData, parentCode, orgCode },
      };
      this.dialogVisible = true;
    },
    async usersByDeptCode(deptCode) {
      this.userLoading = true;
      const res = await findUsersByDeptCode({
        deptCode,
      });
      if (res.success) {
        this.userList = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }

      setTimeout(() => {
        this.userLoading = false;
      }, 300);
    },
    handleEdit() {
      const row = this.curRow;
      if (row) {
        this.deptDialogData = { action: "edit", data: row };
        this.dialogVisible = true;
      } else {
        this.$message.warning({ showClose: true, message: "请选择行数据" });
      }
    },
    handleUserEdit() {
      let row = this.curUser;
      const selection = this.$refs.userPageTable.getSelection();
      if (selection && selection.length > 0) {
        row = selection;
      }
      if (row) {
        this.dialogUserData = { action: "edit", data: row };
        this.dialogUserVisible = true;
      } else {
        this.$message.warning({ showClose: true, message: "请选择行数据" });
      }
    },
    handleUserView() {
      let row = this.curUser;
      const selection = this.$refs.userPageTable.getSelection();
      if (selection && selection.length > 0) {
        row = selection;
      }
      if (row) {
        this.dialogUserData = { action: "view", data: row };
        this.dialogUserVisible = true;
      } else {
        this.$message.warning({ showClose: true, message: "请选择行数据" });
      }
    },
    handleView() {
      const row = this.curRow;
      if (row) {
        this.deptDialogData = { action: "view", data: row };
        this.dialogVisible = true;
      } else {
        this.$message.warning({ showClose: true, message: "请选择行数据" });
      }
    },
    dialogVisibleChange(val) {
      this.dialogVisible = val;
    },
    dialogUserChange(val) {
      this.dialogUserVisible = val;
    },
    async dialogDeptCallBack(res) {
      if (res.success) {
        this.$message({
          showClose: true,
          message: "保存成功",
          type: "success",
        });
        await this.fetchDeptsData();
      } else {
        this.$message.error(res.message);
      }
    },
    async dialogUserCallBack(res) {
      if (res.success) {
        this.$message({
          showClose: true,
          message: "保存成功",
          type: "success",
        });
        await this.usersByDeptCode(this.deptCode);
        this.curUser = undefined;
      } else {
        this.$message.error(res.message);
      }
    },
    async initDialogData(data) {
      return data.data;
    },
    async saveDialogData(data) {
      if (data.isCorporation == "1") {
        data.orgCode = data.deptCode;
      }
      const res = await saveDept({ department: JSON.stringify(data) });
      return res;
    },
    async saveDialogUserData(data) {
      data.name = data.userCode;
      const res = await saveUser({ users: JSON.stringify([data]) });
      return res;
    },
  },
};
</script>

<style scoped lang="scss">
@import "public/static/scss/commTableLayouts";

.el-card {
  margin-bottom: 0;
}

.el-card__header {
  padding: 8px 20px;
}

.el-card__body {
  padding: 0 10px 0 10px;
}

.split-pane {
  display: flex;
  .paneL {
    width: 50%;
  }
}

.paneR {
  flex: 1;
}

.pane-trigger {
  width: 10px;
  height: 100%;
  background: palegoldenrod;
}

.user-box {
  height: calc(#{$base-app-main-height} - 6px);
}
#appScrollbar {
  height: calc(#{$table-box-height} - 25px);
}
</style>
